import { RestClientAuthenticated } from '../network';
import { EntityDTO, EntityList } from './types/compte/EntityDTO';

const entityApi = {
  fetchEntitiesBySearch: (search: string): Promise<EntityList> => new RestClientAuthenticated('/moncompte/entites/lookup', 'GET', 'application/json')
    .addParam('search', search)
    .execute(),
  fetchEntityById: (entityId: string): Promise<EntityDTO> => new RestClientAuthenticated(`/moncompte/entites/${entityId}`, 'GET', 'application/json')
    .execute(),
};

export default entityApi;
